module.exports = __webpack_public_path__ + "static/media/plus-org.cc94d3b7.svg";